import { render, staticRenderFns } from "./PreventiviView.vue?vue&type=template&id=45191cee&"
import script from "./PreventiviView.ts?vue&type=script&lang=ts&"
export * from "./PreventiviView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports